module.exports = __webpack_public_path__ + "media/bootstrap-icons/blockquote-right-e4874c1a.svg";